<template>
  <div class="FullScCd">
   

        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;">
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('leftNav.navTwelve')}}</h1>
                <div style="float:right;" class="machineName">
                  <label style="margin-right:10px;">{{$t('StepCycleTime.labelTitle1')}}</label>
                  <span>{{machineName}}</span>
                </div>
              </div>
              <div class="tableWrap">
                    <!-- 班组表格 -->
                    <el-table
                      :data="tableDataShift"
                      border
                      style="width: 100%">
                      <el-table-column
                      class-name='merge'
                        :label="$t('CycleDistribution.tabtitle2')"
                        >
                        <template slot-scope="scope">
                          <span class="cells">{{scope.row.currentShift}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                      class-name='merge startTime'
                        :label="$t('CycleDistribution.tableTitle1')"
                        >
                        <template slot-scope="scope">
                          <span class="cells">{{scope.row.startTime | formatDate}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                      class-name='merge endTime'
                        :label="$t('CycleDistribution.tableTitle2')"
                       
                        >
                        <template slot-scope="scope">
                          <span class="cells">{{scope.row.endTime | formatDate}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="total"
                        class-name='merge total'
                        :label="$t('CycleDistribution.tableTitle3')"
                        >
                        <template slot-scope="scope">
                          <span class="cells">{{scope.row.total}}</span>
                        </template>
                      </el-table-column>

                      <el-table-column
                        v-for="(item,index) in tableTile"
                        :key="index"
                        
                        class-name='merge'
                        :label='item.label'
                        >
                        <template slot-scope="scope">
                          <span class="tableCell">{{scope.row[item.prop1]}}</span>
                          <span class="tableCell" v-if="scope.row[item.prop2]!== null">{{scope.row[item.prop2]}}%</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                      class-name='merge'
                        :label="`${$t('CycleDistribution.tableTitle4')} (++++)`"
                        width="100">
                        <template slot-scope="scope">
                          <span class="cells">{{scope.row.checkCacul}}%</span>
                        </template>
                      </el-table-column>
                    </el-table>
              </div>
              
            </div>
        </el-scrollbar>
  
    
  </div>
</template>

<script>

import { formatDate } from '../assets/js/date.js'
// import { Loading } from 'element-ui'

export default {
  name: 'CycleDistribution',
  data () {
    return {
      //  模拟数据
      options: [],
      // 表格数据
      tableData:[],
      // 班组表格数据
      tableDataShift:[],
      // 分页
      nowPage: 1,
      totalPage: null,
      // 班组分页
      nowPageShift: 1,
      totalPageShift: null,
      tableTile:[
        {label: '', prop1: 'groupOneNum', prop2: 'groupOnePercentage'},
        {label: '', prop1: 'groupTwoNum', prop2: 'groupTwoPercentage'},
        {label: '', prop1: 'groupThreeNum', prop2: 'groupThreePercentage'},
        {label: '', prop1: 'groupFourNum', prop2: 'groupFourPercentage'},
        {label: '', prop1: 'groupFiveNum', prop2: 'groupFivePercentage'},
        {label: '', prop1: 'groupSixNum', prop2: 'groupSixPercentage'},
      ],
      // 选中的tab name值
      tabIndex:"2",
      machineName: '',
      defaultId: 109,
      timer: ''
    }
  },
  mounted() {
    this.$store.commit('authority' , this.$route.path)
    this.getId()
  },
  destroyed(){
    clearInterval(this.timer)
  },
  filters: {
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'MM-dd hh:mm')
    }
  },
  methods: {
    getId(){
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/getBigscreenMachine'
      }).then(function(res){
        if (res.data.success === 'false') {
          _this.$message.error(res.data.msg);
        }else{
          _this.defaultId = res.data.machine.id
          _this.getTableData()
          _this.timing()
        }
      })
    },
    getTableData(){
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/getCycleDistributionData',
        params: {
          machineId: _this.defaultId,
          disType: _this.tabIndex,
          pageNum: 1,
          pageSize: 10
        }
      }).then(function (res) {
        if (res.data.success === 'true') {
          for (const [index, item] of _this.tableTile.entries()) {
            item.label = res.data.cycleDistributionTitle[index]
          }
          if(_this.tabIndex === '1'){
            _this.tableData = res.data.cycleDistributionList
            _this.totalPage = res.data.total
          }else{
            _this.tableDataShift = res.data.cycleDistributionList
            _this.totalPageShift = res.data.total
          }
          _this.machineName = res.data.machine.nameZh
          
        } else {
          _this.$message.error(_this.$t('CycleDistribution.error1'))
        }
      })
    },
    // 定时刷新
    timing(){
      let _this = this
      this.timer=setInterval(function(){
        _this.getTableData()
      },30000)
    }
  }
}
</script>
<style scoped>
.mainWrao{
  height: 100%;
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 1.42rem 1.78rem;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 2.5rem;
}
.recordTitle h1{
  font-size: 1.78rem;
  font-weight: bold;
  color: #525f7f;
  display: inline-block;
}
.machineName label, .machineName span{
  font-size: 1.78rem;
}
.tableWrap{
  box-sizing: border-box;
  margin: 0.71rem;
}
.tableCell{
  display: inline-block;
  width: 50%;
  padding: 0 0.5rem;
  box-sizing: border-box;
}
.cells{
  padding: 0 0.5rem;
}
.tableCell:nth-child(1){
  border-right: 1px solid #ebeef5
}
.pagination{
  text-align: center;
  margin-top: 35px;
}
.export{
  width: 100px;
  margin-bottom: 15px;
}
</style>

